module.exports = vendor_4adf5b975b06d7f766a2;


//////////////////
// WEBPACK FOOTER
// external "vendor_4adf5b975b06d7f766a2"
// module id = 0
// module chunks = 0